
import extend from '@/utils/vuex-extend';
import { base } from '@/vuex-extend';
import { fetchList, createMenu, updateMenu, getMenu } from '@/api/menu';
import { Message } from 'element-ui';

const defaultForm = {
    title: '',
    parentId: 0,
    name: '',
    icon: '',
    hidden: 0,
    sort: 0
}

export default extend(base, {
    namespaced: true,
    state: {
        form: Object.assign({}, defaultForm),
        selectMenuList: []
    },
    actions: {
        async getSelectMenuList({ commit }) {
            const response = await fetchList({
                parentId: 0,
                pageSize: 100,
                pageNum: 1
            });
            commit('save', {
                selectMenuList: [
                    { id: 0, title: '无上级菜单' },
                    ...response.data.list
                ]
            });
        },
        async getMenu({ state, commit }) {
            const { id } = state;
            const response = await getMenu(id);
            commit('save', {
                form: response.data
            })
        },
        async confirm({ state }, payload) {
            const { id, form, isEdit } = state;
            if (!isEdit) {
                await createMenu(form);
            } else {
                await updateMenu(id, form);
            }
            Message({
                type: 'success',
                message: '操作成功',
                duration: 1000,
                onClose: () => {
                    history.back();
                }
            })
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/modules/ums/menu/detail.js